// TODO: Migrate to sanity
export const testimonies = {
  step4: (
    <>
      <p className="leading-6">
        Home Instead has been helping my mother for well over a year now and
        have given her incredible care, love and support. Their attention to
        detail and patience to her needs is amazing.
      </p>
      <p className="font-bold text-md">— David C.</p>
    </>
  ),
  step5: (
    <>
      <p className="leading-6">
        My father&apos;s caregiver was the perfect match for dad. She took good
        care of him and we could breathe a sigh of relief knowing he was being
        well cared for. We will definitely recommend Home Instead to anyone we
        know that is looking for care.
      </p>
      <p className="font-bold text-md">— Donna M.</p>
    </>
  ),
};

export const testimoniesAlternative = {
  step4: (
    <>
      <p className="leading-6">
        Very pleased with the level of care for my mother. The Home Instead
        caregivers are kind and patient, and it gives me peace of mind.
      </p>
      <p className="font-bold text-md">— Cynthia I.</p>
    </>
  ),
  step5: (
    <>
      <p className="leading-6">
        The overall experience of this Home Instead was exceptional! Thank you
        for your love and support during our time of need. We will miss you all.
      </p>
      <p className="font-bold text-md">— Michael S.</p>
    </>
  ),
};
